import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {reduxForm} from 'redux-form/immutable';
import ReCAPTCHA from "react-google-recaptcha";

import {InputField} from 'common/fields';

const validate = input => {
	const errors = {};
	if (!input.get('card')) {
		errors.card = 'Введите номер карты';
	}
	if (!input.get('name')) {
		errors.name = 'Введите ваше имя';
	}
	return errors;
};

@reduxForm({
	form: 'cardCreateForm',
	validate,
	enableReinitialize: true,
})
export default class extends Component {
	static propTypes = {
		loading: PropTypes.bool,
		handleSubmit: PropTypes.func,
		onSubmit: PropTypes.func,
		error: PropTypes.string,
	};

	constructor(props) {
		super(props);
		this.recaptchaRef = React.createRef();
	}

	onSubmit = props => {
		const {onSubmit} = this.props;
		const recaptchaToken = this.recaptchaRef.current.getValue();
		onSubmit({
			...props.toJS(),
			recaptchaToken,
		}, () => this.recaptchaRef.current.reset());
	};

	render() {
		const {
			error,
			loading,
			handleSubmit,
		} = this.props;

		return (
			<form onSubmit={handleSubmit(this.onSubmit)}>
				<div className="form">
					<div className="form-group">
						<label htmlFor="field-name">Имя Фамилия</label>
						<InputField
							id="field-name"
							name="name"
							type="text"
							className="form-control"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="field-phone">Номер телефона</label>
						<InputField
							id="field-phone"
							name="phone"
							type="text"
							className="form-control"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="field-email">Email</label>
						<InputField
							id="field-email"
							name="email"
							type="text"
							className="form-control"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="field-birthday">Дата рождения</label>
						<InputField
							id="field-birthday"
							name="birthday"
							type="text"
							className="form-control"
							placeholder="ДД.MM.ГГГГ"
						/>
					</div>
					<div className="form-group">
						<label htmlFor="field-recaptcha">Поставьте галочку</label>
						<ReCAPTCHA
							ref={this.recaptchaRef}
							sitekey="6LfIPbwUAAAAAJ0x6xVVlAsv27S3NLkqydRxxfhq"
							className="recaptcha-wrapper"
						/>
					</div>
					<div className="form-group">
						<input
							type="submit"
							className="btn btn-block btn-default"
							value="Создать карту"
							disabled={loading}
						/>
					</div>
					<p className="policy">
						Нажимая на кнопку, я соглашаюсь на передачу
						и использование персональных данных.
					</p>
				</div>
				{error && (
					<div className="text-center text-danger">{error}</div>
				)}
			</form>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/card/CreateFormComponent.js